import { ValidationItemContainer } from "../../../../reporting/report-lists/reports/copyto/CompanyMultipleReportsListItemContainer";
import { ReportInProgress } from "../../../../reporting/report-lists/reports/copyto/controls/ReportInProgress";
import type { CopyCompanyTile } from "../../hooks/CopyCompany";
import { Copied } from "../Copied";
import { CopyError } from "../CopyError";
import { CopyWaiting } from "../CopyWaiting";

interface Props {
  tile: CopyCompanyTile;
}

export const ArbitraryTileItemCopying = ({ tile }: Props) => {
  return (
    <ValidationItemContainer
      caption={tile.tile.tile.widget.nameUserInput || "(No name)"}
      active={true}
      completed={tile.copied}
    >
      {tile.copying && <ReportInProgress text="Copying..." />}
      {!tile.copying && !tile.copied && !tile.error && <CopyWaiting />}
      {tile.error && <CopyError errorMessage={tile.error} />}
      {tile.copied && <Copied />}
    </ValidationItemContainer>
  );
};
